'use client';

import { Label } from '@/components/originui/label';
import { SalesRound } from '@/types/api/sale';
import { ListBox, ListBoxItem } from 'react-aria-components';

interface SalesRoundListboxProps {
  rounds: SalesRound[];
  value: string;
  label: string;
  onChange: (value: string) => void;
}

export default function SalesRoundListbox({ rounds, value, onChange, label }: SalesRoundListboxProps) {
  return (
    <div className="*:not-first:mt-2">
      <Label className="flex items-center justify-between mb-2" htmlFor={label}>
        <div>Försäljningsomgång</div>
        <div>Sista beställningsdag</div>
        <div>Leverans från</div>
      </Label>
      <div className="border-input overflow-hidden rounded-md border">
        <ListBox
          className="bg-background space-y-1 p-1 text-sm shadow-xs transition-[color,box-shadow]"
          aria-label="Select framework"
          selectionMode="single"
          defaultSelectedKeys={[value]}
          selectedKeys={[value]}
          onSelectionChange={(value: Set<string>) => onChange(...(value.keys() as unknown as [string]))}
        >
          {rounds.map((round) => (
            <ListBoxItem
              id={round.id}
              className="data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-focus-visible:border-ring data-focus-visible:ring-ring/50 relative rounded px-2 py-1.5 outline-none data-disabled:cursor-not-allowed data-disabled:opacity-50 data-focus-visible:ring-[3px] flex justify-between"
            >
              <div className="truncate w-32">{round.name}</div>
              <div>{new Date(round.cutoffAt).toLocaleDateString('sv-SE')} </div>
              <div>{new Date(round.deliveryFrom).toLocaleDateString('sv-SE')} </div>
            </ListBoxItem>
          ))}
        </ListBox>
      </div>
    </div>
  );
}
